import { ChangeDetectionStrategy, Component } from "@angular/core";
import { LookerMemberManagementDashboardType } from "../../looker-member-management-dashboard-type.enum";
import { HideFilters } from "../../models/analytics-hide-filters.enum";

@Component({
  selector: "app-error-review-dashboard",
  templateUrl: "./error-review-dashboard.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorReviewDashboardComponent {
  filters: string[] = ["Projects"];
  dashboardType = LookerMemberManagementDashboardType.Error_Review_Dashboard;
  hideFilters: string[] = [HideFilters.PROJECT_IDUPPER, HideFilters.USER_IDUPPER, HideFilters.ORG_IDUPPER, HideFilters.CUSTOMER_NAME2];
}
